import React, {
	ChangeEvent,
	useCallback,
	useContext,
	useEffect,
	useState,
} from 'react';

import { Row, Col } from 'antd';

// ROUTES
import { useHistory } from 'react-router-dom';
import { ROUTE_IIRGD_REIMPRESSAO_PROTOCOLO } from 'pages/iirgd/routes/paths';

// REDUX
import { useDispatch, useSelector } from 'react-redux';

import { ApplicationState } from 'store';
import {
	consultaReimpressaoFicRequest,
	consultaReimpressaoFicClear,
} from 'store/modules/api/iirgd/consultaReimpressaoFic/actions';
import {
	consultaCpfRequest,
	consultaCpfClear,
} from 'store/modules/api/iirgd/pesquisaCicp/actions';

// COMPONENTS
import InputMask from 'components/Common/Form/Input/InputMask';
import ButtonImage from 'components/Common/ButtonImage';
import CardReimpressao from 'components/Common/CardReimpressao';
import { limparMascara } from 'utils/genericFunctions';
import { AuthContext, IAuthContext } from 'react-oauth2-code-pkce';

const ReimpressaoProtocoloFic: React.FC = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const { token } = useContext<IAuthContext>(AuthContext);
	const { login } = useSelector(
		(state: ApplicationState) => state.api.sgu.loginUnico,
	);

	const { consultaReimpressaoFic } = useSelector(
		(state: ApplicationState) => state.api.iirgd,
	);

	const dataCicp = useSelector(
		(state: ApplicationState) => state.api.iirgd.pesquisaCicp.data,
	);

	const [hasSubmit, setHasSubmit] = useState<boolean>(false);
	const [numeroRg, setNumeroRg] = useState<string>('');
	const [numeroCpf, setNumeroCpf] = useState<string>('');

	useEffect(() => {
		if (hasSubmit && consultaReimpressaoFic.status === 200) {
			history.push(ROUTE_IIRGD_REIMPRESSAO_PROTOCOLO);
		}
	}, [hasSubmit, consultaReimpressaoFic.status, history]);

	const handleChangeRg = useCallback((e: ChangeEvent<HTMLInputElement>) => {
		setNumeroRg(e.target.value);
	}, []);

	const handleChangeCpf = useCallback(
		(change: ChangeEvent<HTMLInputElement>) => {
			const { value } = change.target;

			setNumeroCpf(value);
		},
		[],
	);

	const handleDispatchRg = useCallback(
		(rgManual: string) => {
			const rgFinal = rgManual;
			const { idUsuario, senhaMainFrame } = login.mainframe;

			const rgSemMascara = limparMascara(rgFinal.replaceAll('-', ''));
			if (rgFinal && (rgFinal.length === 10 || rgFinal.length === 11)) {
				dispatch(
					consultaReimpressaoFicRequest(token, {
						posto: login.user.posto ? Number(login.user.posto) : 0,
						digito: login.user.digito_posto
							? Number(login.user.digito_posto)
							: 0,
						nome: login.user.nomePosto,
						rg: rgSemMascara,
						usuario: {
							usuario: idUsuario,
							senha: senhaMainFrame,
						},
					}),
				);
				setHasSubmit(true);
			}
		},
		[dispatch, login, token],
	);

	const handleDispatchCpf = useCallback(() => {
		const numCpf = numeroCpf.split('-');
		const { idUsuario, senhaMainFrame } = login.mainframe;

		if (
			(numeroCpf.length === 9 && numCpf[0] && numCpf[1]) ||
			(numeroCpf.length === 12 && numCpf[0] && numCpf[1])
		) {
			dispatch(
				consultaCpfRequest(token, {
					body: {
						cpf: numCpf[0],
						usuario: idUsuario,
						senha: senhaMainFrame,
					},
					headers: {
						usuario: idUsuario,
						senha: senhaMainFrame,
					},
				}),
			);
		}
	}, [dispatch, numeroCpf, login, token]);

	const handleClick = useCallback(() => {
		if (numeroCpf) {
			handleDispatchCpf();
		}

		if (numeroRg) {
			handleDispatchRg(numeroRg);
		}
	}, [numeroCpf, numeroRg, handleDispatchCpf, handleDispatchRg]);

	useEffect(() => {
		if (dataCicp && dataCicp.length > 0) {
			const rg = dataCicp[0].numeroRg.toString();
			setNumeroRg(rg);
			if (numeroRg) {
				setTimeout(() => {
					handleDispatchRg(rg);
				}, 300);
			}
		}
	}, [dataCicp, handleDispatchRg, numeroRg]);

	useEffect(() => {
		dispatch(consultaReimpressaoFicClear());
		dispatch(consultaCpfClear());
		setNumeroRg('');
		setNumeroCpf('');
	}, [dispatch]);

	return (
		<CardReimpressao
			title="Reimprimir Protocolo (FIC)"
			description="Digite o RGE CIN com dígito para reimpressão:"
		>
			<Row justify="space-between">
				<Col>
					<label>RGE:</label>
					<InputMask
						name="numeroRg"
						mask="99999999-**"
						value={numeroRg}
						onChange={handleChangeRg}
					/>
				</Col>
				<Col>
					<label>CIN</label>
					<InputMask
						name="numeroCpf"
						mask="999999999-**"
						value={numeroCpf}
						onChange={handleChangeCpf}
					/>
				</Col>
				<Col>
					<ButtonImage src="reimprimir" onClick={handleClick} />
				</Col>
			</Row>
		</CardReimpressao>
	);
};

export default ReimpressaoProtocoloFic;
